import { defineStore } from 'pinia'
import { useLocale } from '@library/composables'
import type { RtnCode } from '@library/enums'
import type { ErrorMessageList } from '@library/models/error-message-list'
import { stringTemplate } from '@library/utils/functions'

/** 格式化錯誤訊息的選項 */
export interface FormatErrorMessageOption {
  rtnCode?: RtnCode
  data?: Record<string, any> | null
}

/** 錯誤訊息清單 Store */
export const useErrorMessageListStore = defineStore(
  'error-message-list',
  () => {
    const { apiLang } = useLocale()

    /** 錯誤訊息原始清單 */
    const errorMessageList = ref<ErrorMessageList[]>([])

    /** rtnCode 對應當前語系錯誤訊息的對照表 */
    const errorMessageData = computed((): Record<number, string> => {
      return errorMessageList.value.reduce(
        (prev, current) => {
          const message: string =
            current.messageList.find(({ lang }) => lang === apiLang.value)
              ?.message ?? ''
          prev[current.rtnCode] = message

          return prev
        },
        {} as Record<number, string>
      )
    })

    /** 依 rtnCode 格式化錯誤訊息 */
    const formatErrorMessage = (option: FormatErrorMessageOption): string => {
      const { data, rtnCode } = option

      if (!rtnCode) {
        return ''
      }

      return stringTemplate(errorMessageData.value[rtnCode] ?? '', data)
    }

    /** 設定錯誤訊息清單 */
    const setErrorMessageList = (data: ErrorMessageList[]) => {
      errorMessageList.value = data
    }

    return {
      /** 設定錯誤訊息清單 */
      setErrorMessageList,
      /** 依 rtnCode 格式化錯誤訊息 */
      formatErrorMessage
    }
  }
)
